window.Popper = require("popper.js").default;
require("./sitio");
require("bootstrap");
require("@fancyapps/fancybox");
require("./promo_webpay");
require("./bootstrap/dist/js/bootstrap");

require("./plugins/modernizr-custom");
require("paroller.js");
require("slick-carousel");
require("./modal_promocion");
import Splide from "@splidejs/splide";

// scroll marca menu
function onScroll(event) {
    var scrollPos = $(document).scrollTop();
    $("#menu-extendido .scroll-to").each(function () {
        var currLink = $(this);
        var refElement = $(currLink.attr("href"));
        if (
            refElement.position().top - 100 <= scrollPos &&
            refElement.position().top + refElement.height() > scrollPos
        ) {
            $("#menu-extendido .scroll-to").removeClass("active");
            currLink.addClass("active");
        } else {
            // currLink.removeClass("active");
        }
    });
}
$(document).on("scroll", onScroll);

if ($(".proyecto_casa_nuevo #slide-atributos").length) {
    const slide_atributos = new Splide("#slide-atributos", {
        type: "loop",
        perPage: 3,
        perMove: 1,
        autoplay: true,
        arrows: true,
        pagination: false,
        breakpoints: {
            992: {
                perPage: 4,
            },
            768: {
                perPage: 3,
            },
        },
    }).mount();

    slide_atributos.on("active", function (e) {
        const titulo = $(e.slide).find(".slide-in").data("titulo");
        const texto = $(e.slide).find(".slide-in").data("texto");
        const imagen = $(e.slide).find(".slide-in").data("imagen");
        $("#atributos").find("h3").html(titulo);
        $("#atributos").find("p").html(texto);
        $("#atributos")
            .find(".fondo")
            .css("background-image", `url(${imagen})`);
    });
}


require("./proyecto_casa_nuevo");
